import React from 'react';
import { useNavigate } from 'react-router-dom';

const LoginModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    // Navigate to login page
    navigate('/login');
    onClose();
  };

  const handleSignUp = () => {
    // Navigate to signup page for signup
    navigate('/signup');
    onClose();
  };

  const handleStayLoggedOut = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay">
      <div className="login-modal-container">
        <h2 className="login-modal-title">Thanks for trying Priori</h2>
        <p className="login-modal-subtitle">
          Log in or sign up to get smarter responses, upload files and images, and more.
        </p>
        
        <button 
          onClick={handleLogin}
          className="login-primary-btn"
        >
          Log in
        </button>
        
        <button 
          onClick={handleSignUp}
          className="login-secondary-btn"
        >
          Sign up for free
        </button>
        
        <button 
          onClick={handleStayLoggedOut}
          className="stay-logged-out-link"
        >
          Stay logged out
        </button>
      </div>
    </div>
  );
};

export default LoginModal;